<script setup lang="ts">
import { RouterLink } from "vue-router";
import { useI18n } from "vue-i18n";

import { Button, FormAlert, Input } from "@/shared/ui";

defineProps<{
  name: string;
  phone: string;
  status: "idle" | "saving";
  error?: string;
}>();

const emit = defineEmits<{
  "update:name": [value: string];
  "update:phone": [value: string];
  submit: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="inline-master-create">
    <FormAlert
      v-if="error"
      data-testid="inline-create-error"
      variant="destructive"
      :message="error"
    />

    <div class="inline-master-create__field">
      <label
        class="inline-master-create__label text-sm font-medium"
        for="inline-name"
      >
        {{ t("services.assign.create.nameLabel") }}
      </label>
      <Input
        id="inline-name"
        :model-value="name"
        :disabled="status === 'saving'"
        data-testid="inline-name-input"
        @update:model-value="emit('update:name', $event)"
      />
    </div>

    <div class="inline-master-create__field">
      <label
        class="inline-master-create__label text-sm font-medium"
        for="inline-phone"
      >
        {{ t("services.assign.create.phoneLabel") }}
      </label>
      <Input
        id="inline-phone"
        :model-value="phone"
        :disabled="status === 'saving'"
        data-testid="inline-phone-input"
        @update:model-value="emit('update:phone', $event)"
      />
    </div>

    <p class="inline-master-create__hint text-xs text-muted-foreground">
      {{ t("services.assign.create.hint") }}
      <RouterLink to="/masters" class="inline-master-create__link">
        {{ t("services.assign.create.mastersLink") }}
      </RouterLink>
    </p>

    <Button
      :disabled="!name.trim() || status === 'saving'"
      :loading="status === 'saving'"
      data-testid="inline-submit-btn"
      @click="emit('submit')"
    >
      {{ t("services.assign.picker.next") }}
    </Button>
  </div>
</template>

<style scoped>
.inline-master-create {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.inline-master-create__field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.inline-master-create__label {
  color: var(--foreground);
}

.inline-master-create__hint {
  color: var(--muted-foreground);
}

.inline-master-create__link {
  color: var(--primary);
  text-decoration: underline;
}
</style>
